import { fetchAuthSession } from "@aws-amplify/auth";
import { mockAuth } from "./MockAuth";
import { BASE_URL } from "./constants";

const getAuthToken = async (): Promise<string> => {
  const useMockAuth =
    process.env.REACT_APP_USE_MOCK_AUTH === "true" &&
    process.env.NODE_ENV === "development";

  const authService = useMockAuth
    ? async () => await mockAuth.currentSession()
    : fetchAuthSession;

  const token = (await authService()).tokens?.idToken?.toString();

  if (!token) {
    throw new Error("No auth token found");
  }

  return token;
};

export interface ApiFetchOptions {
  method?: string;
  body?: unknown;
  searchParams?: Record<string, string | number | boolean | undefined | null>;
}

export const apiFetch = async <T>(
  path: string,
  options: ApiFetchOptions = {}
): Promise<T> => {
  const token = await getAuthToken();
  const { method = "GET", body, searchParams } = options;

  let url = `${BASE_URL}${path}`;

  if (searchParams) {
    const params = new URLSearchParams();
    for (const [key, value] of Object.entries(searchParams)) {
      if (value !== undefined && value !== null && value !== "") {
        params.append(key, String(value));
      }
    }
    const paramStr = params.toString();
    if (paramStr) {
      url += `?${paramStr}`;
    }
  }

  const response = await fetch(url, {
    method,
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });

  if (!response.ok) {
    const error = await response
      .json()
      .catch(() => ({ message: response.statusText }));
    throw new Error(error.message || `Request failed: ${response.status}`);
  }

  return response.json();
};
